import * as React from 'react';
import ReactGA from 'react-ga';
import styled from 'styled-components';
import Facebook from "../../Img/fb-btn@3x.png";
import Kakao from "../../Img/kakao-btn@3x.png";
import Url from "../../Img/url-btn@3x.png";

import SocialButton from "../SocialButton";

import {
    shareWithKakaotalk,
    shareWithFacebook,
} from './Kakao';

import CopyToClipboard from "react-copy-to-clipboard";

type SocialButtonListProps = {
    shareLink: string,
    shareTitleButton: string,
    shareName: string,
    shareDescription: string,
};
const analyticsId = 'G-EK0Y8CQQZH';

declare const window: any;
declare const gtag: any;
declare const fbq: any;

const url = window.location.href;
const pathName="https://tarotmoon.co.kr/front/"+window.location.hash+"?utm_source=result&utm_medium=share&utm_campaign=copyofurl";

const alertCopied = () => {
    alert('클립보드에 복사되었습니다.');

}



export const SocialButtonList: React.FC<SocialButtonListProps> = ({ shareLink, shareTitleButton, shareName,shareDescription }) => (

    <ListContainer>
        <SocialButton
            name="페이스북"
            source={Facebook}
            onClick={() => shareWithFacebook(shareLink, shareTitleButton, shareName,shareDescription)}
        />
        <SocialButton
            buttonID="kakao-link-btn"
            name="카카오톡"
            source={Kakao}
            onClick={() => shareWithKakaotalk(shareLink, shareTitleButton, shareName, shareDescription)}
        />
        <CopyToClipboard
            text={pathName}
            onCopy={alertCopied}
        >
        <SocialButton
            name={Url}
            source={Url}
            onClick={() => {
                gtag('event', 'Share_CopyOfUrl' , {
                    event_category: 'Share_CopyOfUrl',
                    event_label: 'Share_CopyOfUrl',
                    value: 'Share_CopyOfUrl'
                })
                fbq('track', 'Share_Facebook' , {
                    value: 'Share_Facebook'
                });
            }}
        />
        </CopyToClipboard>
    </ListContainer>
);

export default SocialButtonList;

const ListContainer = styled.div`
    margin: 15px 0;
    padding: 0 52.5px;
    // width: 100%;
    height: 100%;
    float: left;
     img {
      width: 50px;
      height: 50px;
      padding: 15px 10px 16px;
      cursor: pointer;
    }
`;
